module.exports = __webpack_public_path__ + "img/Frame-min.8f784ee1.png";